import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TemplatesService {
  private _resetFields = new Subject<boolean>();
  public resetFields$ = this._resetFields.asObservable();
  private _updateTemplatesArrPagination = new Subject<number>();
  public updateTemplatesArrPagination$ = this._updateTemplatesArrPagination.asObservable();

  constructor() {}

  resetFields(isReset: boolean) {
    this._resetFields.next(isReset);
  }
  updateTemplatesArrPagination(length: number) {
    this._updateTemplatesArrPagination.next(length);
  }
}
